<template>
	<v-card class="resources-page page pb-1" style="border-radius: 10px; max-width: 600px" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class="resources-page__wrapper">
        <div class="date-wrapper">
          <FilterChipButton
              :isButtonActive="isButtonActive"
              :chipsList="chipsList"
              :clearFilter="clearFilter"
              @handleChipClick="handleChipClick"
              :isAdvancedResources="isAdvancedResources"
              @toggleList="toggleList"
              :listView="listView"
          />
          <div v-if="filterModalIsVisible">
            <FilterModal
                :filterModalIsVisible="filterModalIsVisible"
                :currentModalFilter="currentModalFilter"
                :currentModalLabel="currentModalLabel"
                :selectedChips="selectedChips"
                :filters="filters"
                :dateError="date.error"
                :dateOption="date.option"
                :dateRange="date.selectedRange"
                @closeModal="closeModal"
                @applySelection="applySelection"
                @setItem="setItem"
            />
          </div>
        </div>
				<Banner v-if="banner && !isLoading" :banner="banner"/>

				<v-skeleton-loader
					style="max-width: 600px"
					v-bind="attrs"
					type="card"
					v-if="this.isLoading"
				>
				</v-skeleton-loader>

				<ResourceList
					v-if="
						!this.isLoading &&
						this.resourcesItems.length > 0 &&
						(!isAdvancedResources || listView)
					"
					:resourcesItems="resourcesItems"
				/>
				<AdvancedResourceList
					v-if="
						!this.isLoading &&
						this.resourcesItems.length > 0 &&
						isAdvancedResources &&
						!listView
					"
					:resourcesItems="resourcesItems"
				/>

				<div
					v-if="!this.isLoading && this.resourcesItems.length === 0"
					class="mt-5 align-center"
				>
					<NewsFeedEmpty
						title="Resources is empty at the moment."
						description="Check back later."
					/>
				</div>
					<Pagination
              class="home-page__pagination py-9"
              v-if="resourcesItems.length > 0"
						  :page="filters.page"
						  :pageCount="+pageCount"
						  @pageChange="onPageChange"
					/>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResourceList from '@/components/Resource/ResourceList.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import AdvancedResourceList from '../components/Resource/AdvancedResourceList.vue'
import Pagination from '@/components/Pagination.vue'
import Block from '@/mixins/Block.js'
import PageBlocked from '@/components/PageBlocked'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal'
import Filter from '@/mixins/Filter'
import Banner from '@/components/Banner.vue'

export default {
	name: 'ResourcesPage',
	mixins: [Block, Filter],
	components: {
		Banner,
		FilterChipButton,
		NewsFeedEmpty,
		ResourceList,
		AdvancedResourceList,
		Pagination,
		PageBlocked,
		FilterModal,
	},
	computed: {
		...mapGetters('advertisement', ['banner']),
		...mapGetters('resources', ['resourcesList', 'isLoading', 'listMeta', 'listView']),
		pageTitleText() {
			const { title } = this.$route.query
			if (title != null && title !== '') return title
			return this.isAdvancedResources ? 'Advanced Resources' : 'Resources'
		},

		resourcesItems() {
			return this.resourcesList || []
		},
		pageCount() {
			if (!this.listMeta) {
				return 0
			}
			return +this.listMeta.pageCount
		},
		isAdvancedResources() {
			return parseInt(this.$route.query.advance, 10) === 1
		},
		categoryId() {
			if (this.$route.query.category_id) {
				return this.$route.query.category_id
			}
			return false
		},
    bannerQuery() {
      if (this.categoryId){
        return {
          places: ['resource_folders'],
          place_sub_id: this.$route.query.category_id,
          page: this.filters.page,
        }
      } else {
        return {
          places: ['resource_folders'],
          page: this.filters.page,
        }
      }

    },

	},
	methods: {
		...mapActions('resources', [
			'getResources',
			'getCategories',
			'toggleListView',
			'clearResources',
      'toggleDefaultListView'
		]),
		...mapActions('app', ['setPageTitle']),
		...mapActions('advertisement', ['getBanner', 'clearBanner']),
    getBannerPayload() {
      const payload = { ...this.bannerQuery }
      if (this.selectedChips.chapters?.length) {
        payload.chapter_id = this.selectedChips.chapters
      }

      return payload
    },

    loadBanner() {
      this.getBanner(this.getBannerPayload())
    },

		toggleList() {
			this.toggleListView()
		},
	},
	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			pageBlockedName: 'resources',
		}
	},

	created() {
		if (!this.isBlocked || this.isBlocked === null) {
      this.loadBanner()
      this.getResources(this.requestQuery)
		}
	},
	mounted() {
		this.setPageTitle(this.pageTitleText)
	},
	watch: {
		$route() {
			this.setPageTitle(this.pageTitleText)
		},
    '$route.query.advance':{
      handler(newVal, oldVal) {
        if(newVal !== oldVal) {
          this.toggleDefaultListView()
        }
      }
    },
    '$route.query.category_id': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.clearBanner()
          this.clearResources()
          this.loadBanner()
          this.getResources(this.requestQuery)
        }
      },
    },
    'filters.page'(newPage, oldPage) {
      if (newPage !== oldPage) {
        this.loadBanner()
      }
    },
	},
	beforeDestroy() {
		this.setPageTitle('')
		this.clearResources()
		this.clearBanner()
	},
}
</script>

<style lang="scss">
.resources-page {
	max-width: 600px;
	width: 100%;
	border-radius: 10px !important;
	margin-bottom: 30px;
	background-color: transparent !important;

	@media (max-width: 480px) {
		margin-bottom: 12px;
	}

	&__wrapper {
		display: flex;
		flex-direction: column;
	}

	&__title-wrapper {
		display: flex;
		justify-content: flex-end;
		height: 36px;
		flex-wrap: nowrap;
	}

	&__title {
		font-weight: 700;
		font-size: 24px;
		height: 36px;
		line-height: 29px;
		color: #4a4a4a;
		font-family: Montserrat, sans-serif;
	}

	&__list-btn {
		background-color: transparent !important;
		color: var(--accent-color) !important;

		@media (max-width: 480px) {
			margin-top: 8px;
		}
	}
}
</style>
